var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { useModal } from "@animech/ui";
import { useTranslation } from "react-i18next";
import { ImageSelectContainer } from "ui/components/elements/input/image-select/image-select-container";
import { CustomImageSelect } from "ui/components/elements/input/image-select";
import { timeAgo } from "utility/time";
import { useAppSelector, selectors, useAppDispatch, actions as allActions, } from "store";
import { DeleteSystemModal } from "ui/components/modals/ovm-backend/delete-system-modal/delete-system-modal";
import { RenameSystemModal } from "ui/components/modals/ovm-backend/rename-modal.tsx/rename-system-modal";
import { RenameFolderModal } from "ui/components/modals/ovm-backend/rename-modal.tsx/rename-folder-modal";
import { DeleteFolderModal } from "ui/components/modals/ovm-backend/delete-system-modal/delete-folder-modal";
import { countSystemsInFolder, createFolderTree, toFlatMenuOptions, } from "store/user/util";
import { ShareSystemModal } from "ui/components/modals/ovm-backend/share-system-modal/share-system-modal";
export var SavedSystemSelect = function (_a) {
    var systems = _a.systems, folders = _a.folders, onSelectedSystemConfirmed = _a.onSelectedSystemConfirmed, canDrop = _a.canDrop, onDrop = _a.onDrop, onDragStart = _a.onDragStart, draggedItem = _a.draggedItem, highlightSystemId = _a.highlightSystemId;
    var dispatch = useAppDispatch();
    var activeSystem = useAppSelector(selectors.selectUserActiveSystem);
    var activeFolderId = useAppSelector(selectors.selectActiveFolderId);
    var openModal = useModal();
    var t = useTranslation().t;
    var _b = __read(useState(systems.find(function (system) { return activeSystem && system.id === activeSystem.id; })), 2), selectedSystem = _b[0], setSelectedSystem = _b[1];
    var sortByHighlightStatus = useCallback(function (a) { return (a.id === highlightSystemId ? -1 : 0); }, [highlightSystemId]);
    var sortByName = useCallback(function (a, b) {
        return a.name.localeCompare(b.name, undefined, { sensitivity: "base" });
    }, []);
    var sortByLastEdited = useCallback(function (a, b) {
        return a.lastEdited.localeCompare(b.lastEdited, undefined, {
            sensitivity: "base",
        });
    }, []);
    var systemsInActiveFolder = useMemo(function () {
        return systems
            .filter(function (system) { return system.folderId === activeFolderId; })
            .sort(sortByLastEdited)
            .sort(sortByName)
            .sort(sortByHighlightStatus);
    }, [
        systems,
        sortByLastEdited,
        sortByName,
        activeFolderId,
        sortByHighlightStatus,
    ]);
    var foldersInActiveFolder = useMemo(function () {
        return folders
            .filter(function (folder) { return folder.parentId === activeFolderId; })
            .sort(sortByLastEdited)
            .sort(sortByName);
    }, [folders, sortByLastEdited, sortByName, activeFolderId]);
    var labels = foldersInActiveFolder
        .map(function (folder) { return folder.name; })
        .concat(systemsInActiveFolder.map(function (system) { return system.name; }));
    var descriptions = __spreadArray(__spreadArray([], __read(foldersInActiveFolder.map(function (folder) {
        var systemCount = countSystemsInFolder(folder, folders, systems);
        return "".concat(systemCount, " ").concat(t("home-menu.saved-systems.system-count-".concat(systemCount === 1 ? "singular" : "plural")));
    })), false), __read(systemsInActiveFolder.map(function (system) { return system.lastEdited; }).map(timeAgo)), false);
    var images = foldersInActiveFolder
        .map(function () { return "img/app/folder.svg"; })
        .concat(systemsInActiveFolder.map(function (system) { return system.imageSrc; }));
    var values = foldersInActiveFolder
        .map(function (folder) { return folder.id; })
        .concat(systemsInActiveFolder.map(function (system) { return system.id; }));
    var onConfirm = useCallback(function (id) {
        var selectedSystem = systems.find(function (system) { return system.id === id; });
        if (!selectedSystem) {
            return;
        }
        onSelectedSystemConfirmed(selectedSystem);
    }, [onSelectedSystemConfirmed, systems]);
    var onSystemSelected = useCallback(function (id) {
        return setSelectedSystem(systems.find(function (system) { return system.id === id; }));
    }, [systems]);
    var onFolderSelected = useCallback(function (id) {
        dispatch(allActions.setActiveFolderId(id));
    }, [dispatch]);
    var onSystemOrFolderSelected = useCallback(function (id) {
        return folders.find(function (folder) { return folder.id === id; })
            ? onFolderSelected(id)
            : onSystemSelected(id);
    }, [folders, onFolderSelected, onSystemSelected]);
    var onDeleteSystem = useCallback(function (systemId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openModal(_jsx(DeleteSystemModal, { systemId: systemId }));
            return [2 /*return*/];
        });
    }); }, [openModal]);
    var onDeleteFolder = useCallback(function (folderId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openModal(_jsx(DeleteFolderModal, { folderId: folderId }));
            return [2 /*return*/];
        });
    }); }, [openModal]);
    var onRenameSystem = useCallback(function (system) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openModal(_jsx(RenameSystemModal, { system: system }));
            return [2 /*return*/];
        });
    }); }, [openModal]);
    var onShareSystem = useCallback(function (system) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openModal(_jsx(ShareSystemModal, { system: system }));
            return [2 /*return*/];
        });
    }); }, [openModal]);
    var onRenameFolder = useCallback(function (folder) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            openModal(_jsx(RenameFolderModal, { folder: folder }));
            return [2 /*return*/];
        });
    }); }, [openModal]);
    var menuActions = useMemo(function () {
        var folderActions = foldersInActiveFolder.map(function (folder) {
            var tree = createFolderTree(folders, t("home-menu.saved-systems.root-folder"));
            var menuOptions = tree &&
                toFlatMenuOptions(tree, [folder.parentId || undefined], [folder.id]);
            return [
                {
                    label: t("home-menu.saved-systems.rename"),
                    onClick: function () {
                        onRenameFolder(folder);
                    },
                },
                {
                    label: t("home-menu.saved-systems.delete"),
                    onClick: function () {
                        onDeleteFolder(folder.id);
                    },
                },
                {
                    label: t("home-menu.saved-systems.move-to-folder"),
                    onClick: function (folderId) {
                        dispatch(allActions.saveFolder(__assign(__assign({}, folder), { parentId: folderId || null })));
                    },
                    options: menuOptions || [],
                },
            ];
        });
        var systemActions = systemsInActiveFolder.reduce(function (actions, system) {
            var tree = createFolderTree(folders, t("home-menu.saved-systems.root-folder"));
            var unvalidMoveFolderDestinations = [system.folderId || undefined];
            var menuOptions = tree && toFlatMenuOptions(tree, unvalidMoveFolderDestinations, []);
            actions.push([
                {
                    label: t("home-menu.saved-systems.rename"),
                    onClick: function () {
                        onRenameSystem(system);
                    },
                },
                {
                    label: t("home-menu.saved-systems.share"),
                    onClick: function () {
                        onShareSystem(system);
                    },
                },
                {
                    label: t("home-menu.saved-systems.delete"),
                    onClick: function () {
                        onDeleteSystem(system.id);
                    },
                },
                {
                    label: t("home-menu.saved-systems.move-to-folder"),
                    onClick: function (folderId) {
                        dispatch(allActions.saveSystem(__assign(__assign({}, system), { folderId: folderId || null })));
                    },
                    options: menuOptions || [],
                },
            ]);
            return actions;
        }, []);
        return folderActions.concat(systemActions);
    }, [
        foldersInActiveFolder,
        systemsInActiveFolder,
        folders,
        t,
        onRenameFolder,
        onDeleteFolder,
        dispatch,
        onRenameSystem,
        onShareSystem,
        onDeleteSystem,
    ]);
    return (_jsx(_Fragment, { children: _jsx(ImageSelectContainer, { children: _jsx(CustomImageSelect, { canDrop: canDrop, onDragStart: onDragStart, onDrop: onDrop, draggedItem: draggedItem, value: (selectedSystem === null || selectedSystem === void 0 ? void 0 : selectedSystem.id) || "", items: values, itemLabels: labels, itemDescriptions: descriptions, itemImages: images, onValueChange: onSystemOrFolderSelected, onConfirmChoice: onConfirm, withConfirmButton: true, menuActions: menuActions, highlightIndex: values.findIndex(function (value) { return value === highlightSystemId; }) }) }) }));
};
